import {
	AddArticleContentStreamDTO,
	IssueModel,
	ContentStreamIssueDTO,
	ContentStreamFinalizeDTO
} from "@/Generated/ParticaAPI";
import { ContentStreamIssueClient } from "@/Generated/ParticaAPI";
import { ArticleUtils } from "./articleutils";
import { IArticle } from "@/Models/ArticleModels/article";

export interface IContentStreamIssueService {
	addArticleToContentStream(addArticleContentStreamDTO: AddArticleContentStreamDTO): Promise<any>;
	getIssue(issueId: number): Promise<IssueModel>;
	saveContentStreamIssue(issueDTO: ContentStreamIssueDTO): Promise<ContentStreamIssueDTO>;
	finalizeIssue(issueId: number): Promise<any>;
	RemoveArticleFromIssue(ArticleId: string): Promise<any>;
	GetArticlesForIssue(issueId: number): Promise<IArticle[]>;
	DeleteIssue(issueId: number): Promise<any>;
}

export class ContentStreamIssueService implements IContentStreamIssueService {
	private svc: ContentStreamIssueClient = new ContentStreamIssueClient();
	private articleUtils: ArticleUtils = new ArticleUtils();

	public async DeleteIssue(issueId: number): Promise<any> {
		return await this.svc.deleteIssue(issueId);
	}

	public async GetArticlesForIssue(issueId: number): Promise<IArticle[]> {
		const data = await this.svc.getArticlesForIssue(issueId);
		return this.articleUtils.convertarticlearray<IArticle>(data);
	}

	public async RemoveArticleFromIssue(articleId: string): Promise<any> {
		return await this.svc.removeArticleFromIssue(articleId);
	}

	public async finalizeIssue(issueId: number): Promise<any> {
		return this.svc.finalizeIssue({ contentStreamIssueId: issueId } as ContentStreamFinalizeDTO);
	}

	public async addArticleToContentStream(addArticleContentStreamDTO: AddArticleContentStreamDTO): Promise<any> {
		return this.svc.addArticleToContentStream(addArticleContentStreamDTO);
	}
	public async getIssue(issueId: number): Promise<IssueModel> {
		return this.svc.getIssue(issueId);
	}
	public async saveContentStreamIssue(issueDTO: ContentStreamIssueDTO): Promise<ContentStreamIssueDTO> {
		return this.svc.saveContentStreamIssue(issueDTO);
	}
}
